import { Label, RadialBar, RadialBarChart, PolarGrid, PolarRadiusAxis, PolarAngleAxis } from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  CardFooter,
} from "../ui/card";
import {
  ChartContainer,
} from "../ui/chart";

export const description = "AC Load Value";

export function ACLoad(props) {
  const maxValue = 100;

  const getColor = (value) => {
    if (value >= 0 && value <= 20) {
      return "#3CB371"; // Green 
    } else if (value > 20 && value <= 30) {
      return "#FFA500"; // Orange
    } else if (value > 30) {
      return "#FF4500"; // Red
    } else {
      return "#D3D3D3"; // Grey as default
    }
  };

  const chartData = [
    {
      acLoad: props.acLoad,
      value: parseFloat(props.acLoad?.match(/\d+(\.\d+)?/)?.[0] || "0"),
      fill: getColor(parseFloat(props.acLoad?.match(/\d+(\.\d+)?/)?.[0] || "0")),
    },
  ];

  return (
    <Card className="flex flex-col min-h-[300px] min-w-[250px]">
      <CardHeader className="flex flex-col items-center pb-0 text-center">
        <CardTitle className="whitespace-normal break-words">
          Magnetic Field Consumption
        </CardTitle>
        <CardDescription>Live</CardDescription>
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <ChartContainer
          config={chartData}
          className="mx-auto aspect-square max-h-[250px] min-h-[200px]"
        >
          <RadialBarChart
            data={chartData}
            startAngle={0}
            endAngle={360}
            innerRadius={80}
            outerRadius={110}
          >
            <PolarGrid
              gridType="circle"
              radialLines={false}
              stroke="none"
              className="first:fill-muted last:fill-background"
              polarRadius={[86, 74]}
            />
            <PolarAngleAxis type="number" domain={[0, maxValue]} tick={false} />
            <RadialBar dataKey="value" background cornerRadius={10} />
            <PolarRadiusAxis tick={false} tickLine={false} axisLine={false}>
              <Label
                content={({ viewBox }) => {
                  if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                    return (
                      <text
                        x={viewBox.cx}
                        y={viewBox.cy}
                        textAnchor="middle"
                        dominantBaseline="middle"
                      >
                        <tspan
                          x={viewBox.cx}
                          y={viewBox.cy}
                          className="fill-foreground text-4xl font-bold"
                        >
                          {props.acLoad}
                        </tspan>
                      </text>
                    );
                  }
                }}
              />
            </PolarRadiusAxis>
          </RadialBarChart>
        </ChartContainer>
      </CardContent>
      <CardFooter className="flex-col gap-2 text-sm">
      </CardFooter>
    </Card>
  );
}